<template>
    <div>
        <AppNavbar />
        <PagesHero :breadcrumbData="{
            title: $t('faq.title'),
            subtitle: {
                first_text: $t('faq.label'),
                first_href: '/',
                second_text: $t('faq.title')
            }
        }" />
        <div class="container">
            <div class="row">
                <div class="col-lg-6 col-12">
                   <QuestionsAccordions/>
                </div>
                <div class="col-lg-6 col-12">
                    <img src="@/assets/images/faq/main.webp" alt="Questions" class="img">
                </div>
            </div>
        </div>
        <AppFooter />
    </div>
</template>

<script>
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import PagesHero from '@/components/PagesHero.vue';
import QuestionsAccordions from '@/components/Faq/QuestionsAccordions.vue'
export default {
    components: {
        AppFooter, AppNavbar, PagesHero, QuestionsAccordions
    }
}
</script>

<style scoped>
.row {
    margin-top: 40px;
}

.img {
    height: 418px;
    width: auto;
    object-fit: cover;
    margin-bottom: 50px;
    padding: 20px;
}

h2 {
    font-size: 36px;
    font-weight: 500;
    margin-bottom: 30px;
}

p {
    font-size: 22px;
    font-weight: 400;
    margin-bottom: 40px;
}

h3 {
    font-size: 22px;
    font-weight: 500;
}

span {
    font-size: 22px;
    font-weight: 400;
}

.container {
    padding-bottom: 80px;
}

.pros {
    height: 55px;
    width: auto;
    object-fit: contain;
    margin-inline-end: 10px;
}

.pros_container {
    margin-bottom: 40px;
}

.pros_container .flex-row {
    margin-bottom: 50px;
}
</style>